import type { SVGProps } from 'react'
const SvgSyScan = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path d="M1.5 12.264a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h21.13a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z" />
			<path
				d="M15.781 2.75a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h1.645A2.576 2.576 0 0 1 20 6.824v1.953a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V6.824a4.09 4.09 0 0 0-4.074-4.074zm-7.402 0-1.682.002A4.08 4.08 0 0 0 2.631 6.82v1.957a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V6.82a2.56 2.56 0 0 1 2.568-2.568l1.68-.002a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75"
				opacity={0.4}
			/>
			<path d="M20.75 12.264a.75.75 0 0 0-.75.75v4.53a2.58 2.58 0 0 1-2.574 2.577H15.78a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h1.645c2.238 0 4.074-1.839 4.074-4.076v-4.531a.75.75 0 0 0-.75-.75m-17.369 0a.75.75 0 0 0-.75.75v4.535a4.08 4.08 0 0 0 4.067 4.07l1.682.002a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75l-1.68-.002a2.56 2.56 0 0 1-2.568-2.57v-4.535a.75.75 0 0 0-.75-.75" />
		</g>
	</svg>
)
export default SvgSyScan
